export default class Home {
    constructor() {
    	this.language();
        // this.getPopin();
    }

    language() {
        const links = document.querySelectorAll('aside.language-popin .text-container a');
        Array.from(links).forEach( link => {
            link.addEventListener('click', function(e){
                e.preventDefault();
                if (this.href == window.location.href) {
                    document.querySelector('aside.language-popin').classList.remove('open');
                    document.querySelector('.home video').play();
                    document.querySelector('.home video').volume = .5;
                } else {
                    window.location.href = this.href;
                }
                localStorage.setItem('language', 'true');
            } );
        } );
    }

    getPopin() {
        if (localStorage.getItem('language') != 'true') {
            document.querySelector('aside.language-popin').classList.add('open');
        } else {
            document.querySelector('.home video').muted = true;
            document.querySelector('.home video').play();
        }
    }
}